module.exports = __webpack_public_path__ + "static/series_900-df65557a436283de3ed8f5f46acf8b95.png";